import { AdminPermissions } from '../model/adminPermissions';
export class AdminPermissionsBuilder {
    static buildAdminPermissions(data) {
        let permissions = new AdminPermissions();
        permissions.id = data.id;
        permissions.name = data.name;
        return permissions;
    }
}
//# sourceMappingURL=adminPermissions-builder.js.map